import {pluralize} from './utils';

/*
    Given a UTC timestamp for a time in the past,
    return a human-readable label describing how long ago that was.
 */
function getTimeSinceUTCDate(utc_timestamp) {
  const diffMinutes = utc_timestamp.diffMinutes(XDate());

  let i = Math.floor(diffMinutes / 8640); // 6 days
  if (i >= 1) return utc_timestamp.toString('MMMM d, yyyy');
  i = Math.floor(diffMinutes / 1440); // Days
  if (i >= 1) return `${pluralize('day', i)} ago`;
  i = Math.floor(diffMinutes / 60); // Hours
  if (i >= 1) return `${pluralize('hour', i)} ago`;
  i = Math.floor(diffMinutes); // Minutes
  if (i >= 1) return `${pluralize('min', i)} ago`;
  return 'just now';
}

export {getTimeSinceUTCDate};
